import { TextField, Typography } from '@scale/scaleui';
import { AdditionalConstraint, AdditionalConstraintType } from '@scale/shared-types';
import {
  MultiTurnInteractionConfiguration,
  InteractionStepType,
  PromptInputStepParams,
  ModelResponseEditorStepParams,
} from '@scale/shared/types/chat';
import {
  PROMPT_CONSTRAINTS_HINT,
  RESPONSE_CONSTRAINTS_HINT,
  ADDITIONAL_REFERENCE_TEXT_HINT,
} from 'react-scale/lib/ml_constants';

interface MLQualitySettingsProps {
  name: string;
  value: MultiTurnInteractionConfiguration;
}

const getConstraintString = (value: AdditionalConstraint) => {
  if (value.type === AdditionalConstraintType.FieldId) {
    return `${value.type}: ${value.fieldId}`;
  } else {
    return `${value.type}: ${value.freeText}`;
  }
};

const MLQualitySettings = ({ name, value }: MLQualitySettingsProps) => {
  let promptConstraints;
  let responseConstraints;
  let additionalReferenceText;

  value.before.forEach(step => {
    if (step.type === InteractionStepType.PromptInput) {
      const params = step as PromptInputStepParams;
      promptConstraints = params.params.prompt_constraints?.map(getConstraintString);
    }
  });
  value.turn.forEach(step => {
    if (step.type === InteractionStepType.ModelResponseEditor) {
      const params = step as ModelResponseEditorStepParams;
      if (params.params.response_constraints) {
        responseConstraints = params.params.response_constraints?.map(getConstraintString);
      }
      if (params.params.additional_reference_text) {
        additionalReferenceText = params.params.additional_reference_text;
      }
    }
  });

  return (
    <div className="scaleui scaleui-tailwind scale-theme">
      <div className="flex flex-col gap-2 my-4">
        <Typography.H3>{name}</Typography.H3>
      </div>
      <div className="space-y-2">
        <TextField
          id="promptConstraints"
          label="Prompt Constraints"
          value={promptConstraints}
          readOnly={true}
          labelDescription={PROMPT_CONSTRAINTS_HINT}
        />
        <TextField
          id="responseConstraints"
          label="Response Constraints"
          value={responseConstraints}
          readOnly={true}
          labelDescription={RESPONSE_CONSTRAINTS_HINT}
        />
        <TextField
          id="additionalReferenceText"
          label="Additional Reference Text"
          value={additionalReferenceText}
          readOnly={true}
          labelDescription={ADDITIONAL_REFERENCE_TEXT_HINT}
        />
      </div>
    </div>
  );
};

export default MLQualitySettings;
